module.exports = function() {
  return new Worker(__webpack_public_path__ + "3dc612be4a1a9d8ffe45.worker.js");
};